<div class="all-content">
  <div class="top">
    <div class="title-skills">
      <span> {{ getLanguages('personas/skills') }} </span>
      <i class="fa-solid fa-plus" (click)="addSkill()" [ngClass]="!parameters.isEdit ? 'no-pointer' : 'pointer'"></i>
      <button class="save button-skills" [disabled]="!parameters.isEdit" (click)="exitModalSkills()" [ngClass]="!parameters.isEdit ? 'no-pointer disabled' : 'pointer'">
        {{ getLanguages('businessSolution/modal/skills/search') }}
      </button>
    </div>
  </div>
  <div class="skills" [ngClass]="openSkills ? 'openned-skills' : 'closed-skills'">
    <div class="skill" *ngFor="let skill of skillsArray">
      <input type="text" [(ngModel)]="skill.name" [disabled]='!parameters.isEdit || skill.in_use'>
      <i class="fas fa-xmark" (click)="removeSkill(skill.uuid)" [ngClass]="!parameters.isEdit ? 'no-pointer' : 'pointer'"></i>
    </div>

    <div class="noData" *ngIf="skillsArray.length == 0">
      <div class="icon">
          <i class="fa-solid fa-exclamation"></i>
      </div>
      <span>
          {{ getLanguages('errors/noData')}}
      </span>
    </div>
  </div>
    <!-- <div class="content-dimension">
        <div class="no-data" *ngIf="!isData()">
          <div class="circle">
            <i class="fas fa-exclamation"></i>
          </div>
          {{ getLanguages('errors/noData') }}
        </div>

        <div class="table-attachment" *ngIf="isData()">
            <table *ngIf="getDisplayedRows().length !== 0"  mat-table [dataSource]="getDisplayedRows()" class="table">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="td-80">
                        <span> {{ getLanguages('attachment/name') }} </span>
                    </th>
                    <td mat-cell *matCellDef="let row" class="td-80">
                        <span class="pointer" (click)="selectTransaction(row)"> {{ row.name }} </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="td-20">
                        <span> {{ getLanguages('attachment/action') }} </span>
                    </th>
                    <td mat-cell *matCellDef="let row" class="td-20">
                        <button (click)="deleteTransaction(row.uuid)" [disabled]="!parameters.isEdit">
                            <i class="fas fa-trash" [ngClass]="!parameters.isEdit ? 'disabled-icon' : 'icon'"></i>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4"></td>
                </tr>
            </table>
        </div>
        <div class="div-paginator" *ngIf="isData()">
          <div class="paginator">
            <span>
              {{ getLanguages('businessSolution/modal/strategy/itensPage') }}
            </span>
            <button [matMenuTriggerFor]="menu" class="itens-per-page">
              {{ getItemsPerPage() }}
            </button>
            <mat-menu #menu="matMenu" >
              <button mat-menu-item (click)="choseItemsPage(5)">5</button>
              <button mat-menu-item (click)="choseItemsPage(10)">10</button>
            </mat-menu>
            <span>
              {{ getLanguages('businessSolution/modal/strategy/totalPages') }}
            </span>
            <span class="totalPages">
              {{ getTotalPages()}}
            </span>
            <button
              [ngClass]="getCurrentPages() === 1 ? 'disabled-arrow' : 'arrow'"
              [disabled]="getCurrentPages() === 1"
              (click)="onPageChange(getCurrentPages() - 1, 'strategy')">
              <i class="fa-solid fa-angle-left"></i>
            </button>
            <input type="number" [ngModel]="getCurrentPages()"  (blur)="checkValue()">
            <button
              [ngClass]="getCurrentPages() == getTotalPages() ? 'disabled-arrow' : 'arrow'"
              [disabled]="getCurrentPages() == getTotalPages()"
              (click)="onPageChange(getCurrentPages() + 1, 'strategy')">
              <i class="fa-solid fa-angle-right"></i>
            </button>
          </div>
        </div>
    </div>

    <div class="row row-end">
        <div class="button-upload" (click)="newTransaction()" [ngClass]="!parameters.isEdit ? 'disabled' : 'pointer'">
            {{ getLanguages('businessSolution/modal/transactions/new_transaction') }}
        </div>
        <div class="button-upload" (click)="saveTransaction()" [ngClass]="!parameters.isEdit ? 'disabled' : 'pointer'">
            {{ getLanguages('businessSolution/modal/transactions/save_transaction') }}
        </div>
    </div>

    <div class="row">
        <div class="item item-1">
          <span> {{ getLanguages('businessSolution/modal/transactions/name') }} </span>
          <input [disabled]="!parameters.isEdit" type="text"  [(ngModel)]="currentTransaction.name">
        </div>
    </div>

    <div class="row">
        <div class="item item-1">
            <section class="position-relative">
              <span class="button-tooltip"> {{ getLanguages('businessSolution/modal/addCode/description') }} <b class="icon-ai"> ai </b> </span>
              <div class="toggle-tooltip margin-left-tooltip">
                <div class="item-op">
                  {{ getLanguages('ai/info') }}
                </div>
              </div>
            </section>
            <textarea [disabled]="!parameters.isEdit" [(ngModel)]="currentTransaction.description"></textarea>
        </div>
    </div> -->
</div>

<div class="background-modals" *ngIf="isShowSkills">
  <app-skills-crud (toggleExit)="exitModalSkills()" (getArray)="getArraySkillsPersona($event)" [parameters]="objectModal"></app-skills-crud>
</div>


